import { render, staticRenderFns } from "./SelectorTipoEsporte.vue?vue&type=template&id=1e52dbf0&scoped=true"
import script from "./SelectorTipoEsporte.vue?vue&type=script&lang=js"
export * from "./SelectorTipoEsporte.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./SelectorTipoEsporte.vue?vue&type=style&index=2&id=1e52dbf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52dbf0",
  null
  
)

export default component.exports